import React from "react";
import { Column } from "@ant-design/charts";

interface FiveGModelsColumnProps {
  data: Array<{ model: string; brand: string; count: string }>;
}

export const FiveGModelsColumn: React.FC<FiveGModelsColumnProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const chartData = data.map((r) => ({
    model: `${r.brand} ${r.model}`,
    count: parseInt(r.count, 10),
  }));

  const config = {
    data: chartData,
    xField: "model",
    yField: "count",
    color: "#FFC900",
    style: {
      maxWidth: 40,
    },
    label: {
      text: (d: any) => String(d.count),
      position: "inside" as const,
      style: { fill: "#1a1a1a", fontWeight: 600 },
    },
    axis: {
      x: {
        labelAutoRotate: true,
        labelFormatter: (text: string) =>
          text.length > 20 ? text.substring(0, 18) + "…" : text,
      },
    },
    tooltip: {
      title: (d: any) => d.model,
      items: [{ channel: "y", name: "Sorgu" }],
    },
  };

  return <Column {...config} />;
};
